<template>
  <v-dialog :value="dialog" max-width="1100" persistent>
    <v-card>
      <v-card-title class="headline accent--text pb-4">
        {{ title }}
      </v-card-title>
      <transition name="animation">
        <v-card-text outlined tile class="border-top py-6" v-if="dialog">

        <IdentityCardComponent
          v-if="[1, 2].includes(application.applicationType?.id)"
          :item="identityCardParent"
          @set-data="identityCardParent = $event"
          @remove="removeIdentityCard"
        />

        <ApplicationRecoveryComponent
          v-if="application.applicationType?.id === 1"
          :item="application"
          @set-data="application = $event"
        />

        <ApplicationOrganizationTransferComponent
          v-if="application.applicationType?.id === 2"
          :item="application"
          @set-data="application = $event"
        />

        <ApplicationEducationTransferComponent
          v-if="application.applicationType?.id === 3"
          :item="application"
          @set-data="application = $event"
        />

        <TrainingCertificateComponent
          :item="trainingCertificateParent"
          @set-data="trainingCertificateParent = $event"
          @remove="removeTrainingCertificate"
        />

        <EducationComponent
          v-if="application.applicationType?.id === 1"
          :item="educationParent"
          @set-data="educationParent = $event"
          @remove="removeEducation"
        />

        <MedicalCertificateComponent
          v-if="application.applicationType?.id === 1"
          :item="medicalCertificateParent"
          @set-data="medicalCertificateParent = $event"
          @remove="removeMedicalCertificate"
        />

        <MilitaryComponent
          v-if="application.applicationType?.id === 1"
          :item="militaryParent"
          @set-data="militaryParent = $event"
          @remove="removeMilitary"
        />

        <AchievementComponent
          :item="achievementParent"
          @set-data="achievementParent = $event"
          @remove="removeAchievement"
        />

      </v-card-text>
      </transition>
      <v-card-actions class="border-top px-6">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" :disabled="loading" @click="closeModal">Закрыть</v-btn>
        <v-btn
          :disabled="disabledBtn"
          :loading="loading"
          color="success"
          text
          @click="saveData"
        >
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

import {
  Application,
  AchievementParent,
  EducationParent,
  IdentityCardParent,
  MedicalCertificateParent,
  MilitaryParent,
  TrainingCertificateParent, IdentityCard, TrainingCertificate, Education, MedicalCertificate, Military
} from '@/models'
import {
  applicationApi,
  achievementApi,
  educationApi,
  identityCardApi,
  militaryApi,
  medicalCertificateApi,
  trainingCertificateApi, fileApi
} from '@/api'
import DatePicker from "@/components/ui/DatePicker"
import FileInputComponent from '@/components/ui/FileInput'
import ApplicationRecoveryComponent from "@/components/zvp/application-create/ApplicationRecovery"
import ApplicationOrganizationTransferComponent from "@/components/zvp/application-create/ApplicationOrganizationTransfer"
import ApplicationEducationTransferComponent from "@/components/zvp/application-create/ApplicationEducationTransfer"
import AchievementComponent from '@/components/zvp/application-create/achievement-doc/Index'
import EducationComponent from '@/components/zvp/application-create/education-doc/Index'
import IdentityCardComponent from '@/components/zvp/application-create/identity-card-doc/Index'
import MedicalCertificateComponent from '@/components/zvp/application-create/medical-certificate-doc/Index'
import MilitaryComponent from '@/components/zvp/application-create/military-doc/Index'
import TrainingCertificateComponent from '@/components/zvp/application-create/training-certificate-doc/Index'
import {mapGetters, mapState} from "vuex";
import _cloneDeep from "lodash/cloneDeep"
import {
  applicationRecovery,
  applicationOrganizationTransfer,
  applicationEducationTransfer,
  achievementDoc,
  militaryDoc,
  trainingCertificateDoc,
  educationDoc,
  medicalCertificateDoc,
  identityCardDoc
} from "@/scripts/rules-validation"

export default {
  name: 'ApplicationCreate',

  components: {
    DatePicker,
    ApplicationRecoveryComponent,
    ApplicationOrganizationTransferComponent,
    ApplicationEducationTransferComponent,
    FileInputComponent,
    AchievementComponent,
    EducationComponent,
    IdentityCardComponent,
    MedicalCertificateComponent,
    MilitaryComponent,
    TrainingCertificateComponent
  },

  props: {
    dialog: Boolean,
    item: Application
  },

  data() {
    return {
      loading: false,
      application: new Application(),
      achievementParent: new AchievementParent(),
      educationParent: new EducationParent(),
      identityCardParent: new IdentityCardParent(),
      medicalCertificateParent: new MedicalCertificateParent(),
      militaryParent: new MilitaryParent(),
      trainingCertificateParent: new TrainingCertificateParent()
    }
  },

  validations() {
    switch (this.application.applicationType?.id) {
      case 1: return {
        application: {...applicationRecovery},
        achievementParent: {list: {$each: {...achievementDoc}}},
        educationParent: {list: {$each: {...educationDoc}}}, // minLength: minLength(1) - не работает, хз
        identityCardParent: {list: {$each: {...identityCardDoc}}},
        militaryParent: {list: {$each: this.isMan ? {...militaryDoc} : {}}},
        trainingCertificateParent: {list: {$each: {...trainingCertificateDoc}}},
      }
      case 2: return {
        application: {...applicationOrganizationTransfer},
        achievementParent: {list: {$each: {...achievementDoc}}},
        identityCardParent: {list: {$each: {...identityCardDoc}}},
        trainingCertificateParent: {list: {$each: {...trainingCertificateDoc}}}
      }
      case 3: return {
        application: {...applicationEducationTransfer},
        achievementParent: {list: {$each: {...achievementDoc}}},
        trainingCertificateParent: {list: {$each: {...trainingCertificateDoc}}}
      }
      default: return {}
    }
  },

  computed: {
    ...mapGetters('dictionaries', ['dictionaries']),
    ...mapGetters('personalData', ['personalDataId']),
    ...mapState('personalData', ['personalData']),

    isMan() {
      return this.personalData.gender?.id === 1
    },

    title() {
      return this.application.applicationType?.name ? this.application.applicationType?.name : ''
    },

    isEdit() {
      return this.item?.id
    },

    disabledBtn() {
      return this.$v.$invalid || this.invalidFiles || !this.checkLength
    },

    checkLength() {
      switch (this.application.applicationType?.id) {
        case 1:
          return this.isMan
            ? this.educationParent.list.length
            && this.identityCardParent.list.length
            && this.trainingCertificateParent.list.length
            && this.militaryParent.list.length
            : this.educationParent.list.length
            && this.identityCardParent.list.length
            && this.trainingCertificateParent.list.length

        case 2:
          return this.identityCardParent.list.length
            && this.trainingCertificateParent.list.length

        case 3:
          return this.trainingCertificateParent.list.length
      }
    },

    invalidFiles() {
      return this.achievementParent.list.some(item => item.filesData.invalid)
        || this.educationParent.list.some(item => item.filesData.invalid)
        || this.identityCardParent.list.some(item => item.filesData.invalid)
        || this.medicalCertificateParent.list.some(item => item.filesData.invalid)
        || this.militaryParent.list.some(item => item.filesData.invalid)
        || this.trainingCertificateParent.list.some(item => item.filesData.invalid)
    }
  },

  methods: {
    async saveData() {
      try {
        this.loading = true
        const data = await this.saveApplication()
        if (data.id) {
          await this.saveTrainingCertificate()
          await this.saveMedicalCertificate()
          await this.saveMilitary()
          await this.saveIdentityCard()
          await this.saveAchievement()
          await this.saveEducation()
        }
        this.$emit('set-application', this.application)
        this.closeModal()
        this.$toastr('success', '', 'Успешно сохранено')
      } catch (e) {
        console.log(e)
        this.showErrorMessage(e)
      } finally {
        this.loading = false
      }
    },

    async saveApplication() {
      try {
        this.application.personalData = this.personalDataId
        const data = this.application.id
          ? await applicationApi.update(this.application.getForAPI())
          : await applicationApi.create(this.application.getForAPI())
        this.application.setProperties(data)
        return data
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveAchievement() {
      try {
        for (const item of this.achievementParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await achievementApi.update(item.getForAPI())
            : await achievementApi.create(item.getForAPI())
          this.pushItem(this.application.achievementList, data)
          data.id && await this.sendFiles(data.id, item, 'Achievement')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveEducation() {
      try {
        for (const item of this.educationParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await educationApi.update(item.getForAPI())
            : await educationApi.create(item.getForAPI())
          this.pushItem(this.application.educationList, data)
          data.id && await this.sendFiles(data.id, item, 'Education')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveIdentityCard() {
      try {
        for (const item of this.identityCardParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await identityCardApi.update(item.getForAPI())
            : await identityCardApi.create(item.getForAPI())
          this.pushItem(this.application.identityCardList, data)
          data.id && await this.sendFiles(data.id, item, 'IdentityCard')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveMedicalCertificate() {
      try {
        for (const item of this.medicalCertificateParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await medicalCertificateApi.update(item.getForAPI())
            : await medicalCertificateApi.create(item.getForAPI())
          this.pushItem(this.application.medicalCertificateList, data)
          data.id && await this.sendFiles(data.id, item, 'MedicalCertificate')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveMilitary() {
      try {
        for (const item of this.militaryParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await militaryApi.update(item.getForAPI())
            : await militaryApi.create(item.getForAPI())
          this.pushItem(this.application.militaryList, data)
          data.id && await this.sendFiles(data.id, item, 'Military')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    async saveTrainingCertificate() {
      try {
        for (const item of this.trainingCertificateParent.list) {
          item.application = {id: this.application.id}
          const data = item.id
            ? await trainingCertificateApi.update(item.getForAPI())
            : await trainingCertificateApi.create(item.getForAPI())
          this.pushItem(this.application.trainingCertificateList, data)
          data.id && await this.sendFiles(data.id, item, 'TrainingCertificate')
        }
      } catch (e) {
        return Promise.reject(e)
      }
    },

    pushItem(arr, item) {
      const index = arr.findIndex(el => el.id === item.id)
      index >=0 ? arr.splice(index, 1, item) : arr.push(item)
    },

    async sendFiles(refId, item, refClassName) {
      try {
        if (item.filesData?.files?.length) {
          for (const el of item.filesData?.files) {
            const data = await fileApi.postFiles(el, refId, refClassName)
            console.log(data)
          }
        }
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeAchievement(item) {
      try {
        if (item.id) {
          await achievementApi.remove(item.id)
          this.$toastr('success', '', 'Успешно удалено')
        }
        this.achievementParent.remove(item)
        this.application.achievementList = this.achievementParent.list
        this.$emit('set-application', this.application)
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeEducation(item) {
      try {
        if (item.id) {
          const cleanedEducation = new Education()
          cleanedEducation.id = item.id
          this.educationParent.update(cleanedEducation)
        } else {
          this.educationParent.remove(item)
        }

        this.application.educationList = this.educationParent.list
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeIdentityCard(item) {
      try {
        if (item.id) {
          const cleanedIdentityCard = new IdentityCard()
          cleanedIdentityCard.id = item.id
          this.identityCardParent.update(cleanedIdentityCard)
        } else {
          this.identityCardParent.remove(item)
        }

        this.application.identityCardList = this.identityCardParent.list
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeMedicalCertificate(item) {
      try {
        if (item.id) {
          const cleanedMedicalCertificate = new MedicalCertificate()
          cleanedMedicalCertificate.id = item.id
          this.medicalCertificateParent.update(cleanedMedicalCertificate)
        } else {
          this.medicalCertificateParent.remove(item)
        }

        this.application.medicalCertificateList = this.medicalCertificateParent.list
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeMilitary(item) {
      try {
        if (item.id) {
          const cleanedMilitary = new Military()
          cleanedMilitary.id = item.id
          this.militaryParent.update(cleanedMilitary)
        } else {
          this.militaryParent.remove(item)
        }

        this.application.militaryList = this.militaryParent.list
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    async removeTrainingCertificate(item) {
      try {
        if (item.id) {
          const cleanedTrainingCertificate = new TrainingCertificate()
          cleanedTrainingCertificate.id = item.id
          this.trainingCertificateParent.update(cleanedTrainingCertificate)
        } else {
          this.trainingCertificateParent.remove(item)
        }
        this.application.trainingCertificateList = this.trainingCertificateParent.list
      } catch (e) {
        this.showErrorMessage(e)
      }
    },

    closeModal() {
      this.$emit('close-dialog')
    },

    resetModal() {
      this.$v.$reset()
      this.application = new Application()
      this.achievementParent = new AchievementParent()
      this.educationParent = new EducationParent()
      this.identityCardParent = new IdentityCardParent()
      this.medicalCertificateParent = new MedicalCertificateParent()
      this.militaryParent = new MilitaryParent()
      this.trainingCertificateParent = new TrainingCertificateParent()
    },
  },

  watch: {
    dialog(value) {
      if (value) {
        this.application = _cloneDeep(this.item)
        if (this.item.id) {
          this.achievementParent.build(this.application.achievementList)
          this.educationParent.build(this.application.educationList)
          this.identityCardParent.build(this.application.identityCardList)
          this.medicalCertificateParent.build(this.application.medicalCertificateList)
          this.militaryParent.build(this.application.militaryList)
          this.trainingCertificateParent.build(this.application.trainingCertificateList)
        }
      } else {
        this.resetModal()
      }
    }
  }
}
</script>
<style scoped>
.animation-enter-active {
  transition: opacity .2s;
}

.animation-leave-active {
  transition: opacity .2s;
}

.animation-enter, .animation-leave-to {
  opacity: 0;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
